import React from 'react';
import Logo from '../../assets/images/bet-on-poker/poker-logo.png';

export function GameName() {
  return (
    <div className='bet-on-poker-logo'>
      <img src={Logo} alt='' />
    </div>
  );
}
